module.exports = __webpack_public_path__ + "img/project_default.d7575ade.png";